export default {
  created: "Оформлен",
  payed: "Оплачен",
  complete: "Завершен",
  cancelled: "Отменен"
}



// WEBPACK FOOTER //
// ./src/features/Personal/containers/OrderItem/statuses.js